import axios from 'axios';

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
});

let getAuthToken = null;
let onUnauthorized = null;
let interceptorsConfigured = false;

export const setAuthTokenProvider = (provider) => {
  getAuthToken = provider;
};

export const setUnauthorizedHandler = (handler) => {
  onUnauthorized = handler;
};

const attachAuthHeader = (config) => {
  const token = typeof getAuthToken === 'function' ? getAuthToken() : null;
  if (!token) return config;

  config.headers = config.headers || {};
  if (!config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

const handleResponseError = (error) => {
  const status = error?.response?.status;
  if ((status === 401 || status === 403) && typeof onUnauthorized === 'function') {
    onUnauthorized(error);
  }
  return Promise.reject(error);
};

export const configureApiInterceptors = () => {
  if (interceptorsConfigured) return;
  interceptorsConfigured = true;

  apiClient.interceptors.request.use(attachAuthHeader);
  apiClient.interceptors.response.use((response) => response, handleResponseError);

  // Keep the existing global axios call sites protected while stores migrate.
  axios.interceptors.response.use((response) => response, handleResponseError);
};

